/**
 * 生成/获取设备唯一标识，存储在 localStorage 中
 */
export function getDeviceId() {
  let deviceId = localStorage.getItem('captcha_device_id')
  if (!deviceId) {
    const array = new Uint8Array(16)
    window.crypto.getRandomValues(array)
    deviceId = Array.from(array, b => b.toString(16).padStart(2, '0')).join('')
    localStorage.setItem('captcha_device_id', deviceId)
  }
  return deviceId
}